import React from "react";

const Java_Static = () => {
  return (
    <div>
      <h1>Java Static</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Static in Java.</p>
    </div>
  );
};

export default Java_Static;
